/**
 * PWA Analytics - Track PWA installation and launch events
 */

import { trackEvent } from './analytics';

// Track PWA installation
if (typeof window !== 'undefined') {
  window.addEventListener('appinstalled', () => {
    trackEvent('pwa_installed');
  });

  // Track PWA launch (from home screen)
  // Check if app is running in standalone mode (installed PWA)
  if (window.matchMedia('(display-mode: standalone)').matches) {
    trackEvent('pwa_launched');
  }
}

